/* eslint-disable import/prefer-default-export */
import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";
// import { baseUrl } from "./baseUrl";

export const searchDocumentTemplatesRoute = ({
  onDate,
  reportTypeId,
}: {
  onDate?: string;
  reportTypeId?: number;
}) =>
  buildUrl({
    url: `${baseUrl}/billing-api/report-templates/search`,
    searchParams: { onDate, reportTypeId },
  });

export const fetchDocumentTemplateVerionsRoute = (reportId: number) =>
  buildUrl({
    url: `${baseUrl}/billing-api/report-templates/${reportId}/versions`,
  });

export const createDocumentTemplateRoute = () =>
  buildUrl({
    url: `${baseUrl}/billing-api/report-templates`,
  });

export const downloadDocumentTemplateFileRoute = ({
  reportId,
  onDate,
}: {
  reportId: number;
  onDate: string;
}) =>
  buildUrl({
    url: `${baseUrl}/billing-api/report-templates/${reportId}/download`,
    searchParams: {
      onDate,
    },
  });

export const updateDocumentTemplateRoute = ({
  reportId,
  fromDate,
  force,
}: {
  reportId: number;
  fromDate: string;
  force: boolean;
}) =>
  buildUrl({
    url: `${baseUrl}/billing-api/report-templates/${reportId}`,
    searchParams: {
      fromDate,
      force,
    },
  });

export const deleteDocumentTemplateRoute = ({
  reportId,
  fromDate,
}: {
  reportId: number;
  fromDate: string;
}) =>
  buildUrl({
    url: `${baseUrl}/billing-api/report-templates/${reportId}`,
    searchParams: {
      fromDate,
    },
  });
